import { useCallback, useState } from "react";

import PageLoading from "components/loading/PageLoading";
import FullScreenModal from "ds/components/FullScreenModal";
import useTitle from "hooks/useTitle";
import useErrorHandle from "hooks/useErrorHandle";
import { showSimpleLeaveConfirmation } from "ds/components/LeaveConfirmationModal/Simple";
import { BitbucketDatacenterIntegration } from "types/generated";

import useCloseFullScreenModal from "../../useCloseFullScreenModal";
import useGetBitbucketDataCenterIntegration from "./useGetBitbucketDataCenterIntegration";
import VCSIntegrationsManageBitbucketDataCenterForm from "../Form";

type VCSIntegrationsManageBitbucketDataCenterEditProps = {
  id: string;
};

const VCSIntegrationsManageBitbucketDataCenterEdit = ({
  id,
}: VCSIntegrationsManageBitbucketDataCenterEditProps) => {
  const [isDirty, setIsDirty] = useState(false);

  const { integration, isPageLoading, error } = useGetBitbucketDataCenterIntegration(id);
  const { handleOnClose } = useCloseFullScreenModal();

  const modalCloseClickHandler = useCallback(async () => {
    if (isDirty) {
      await showSimpleLeaveConfirmation();
    }

    handleOnClose();
  }, [handleOnClose, isDirty]);

  const toggleIsDirty = useCallback((value: boolean) => {
    setIsDirty(value);
  }, []);

  useTitle(`Edit integration · ${integration?.name}`);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <FullScreenModal
      title="Edit Bitbucket Data Center integration"
      onClose={modalCloseClickHandler}
    >
      {isPageLoading && <PageLoading />}
      {!isPageLoading && (
        <VCSIntegrationsManageBitbucketDataCenterForm
          integration={integration as BitbucketDatacenterIntegration}
          onIsDirtyChange={toggleIsDirty}
        />
      )}
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageBitbucketDataCenterEdit;
